<template>
  <div class="space-y-4">
    <ClaimAlerts :claim="claim" :customer="customer" />

    <p v-if="isEmpty" class="text-sm text-green-700">{{ t("nothing_to_report") }}</p>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import ClaimAlerts from "@/components/claim/ClaimAlerts.vue";
import { alertsCount } from "@/components/claim/details/ai-analysis-flow/claimAiAnalysisSummary";

export default {
  name: "AiAnalysisAlertsStep",

  components: { ClaimAlerts },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    claim: {
      type: Object,
      required: true,
    },
    customer: {
      type: Object,
      default: null,
    },
  },

  computed: {
    // Même décompte que la coloration de l'onglet dans la modale : une seule source de vérité.
    isEmpty() {
      return alertsCount(this.claim, this.customer) === 0;
    },
  },
};
</script>

<i18n src="./AiAnalysisAlertsStep.i18n.json"></i18n>
